/* global swal */
import { isEqual } from 'lodash';

export default function($log, Swal, $state) {
  'ngInject';

  const vm = this;
  vm.$onChanges = activate;

  vm.selected = 0;

  vm.onFilter = function(stCtrl) {
    const oldFiltered = (vm.filtered || []).map(({ email }) => email);
    const newFiltered = stCtrl.getFilteredCollection().map(({ email }) => email);
    if (!isEqual(oldFiltered, newFiltered)) vm.selectAllEmployees = false;
    vm.filtered = stCtrl.getFilteredCollection();
  };

  vm.registerMultiple = newUsers => {
    vm.outgoingRequest = true;
    const selected = vm.registrations.filter(user => user.selected);
    vm.selected = 0;
    registerMultipleSwal(newUsers, selected.length)
      .then(data => {
        if (data.dismiss) throw data;
        vm.addRegistrants({ data: selected, suppress: !!vm.suppress, location: data.value });
      })
      .then(() => {
        $state.go('.', {}, { notify: true, reload: true });
      })
      .catch(error => {
        if (error.dismiss) return;
        Swal.toast('Error with registrations', 'error');
        $log.error(error);
        throw error;
      });
  };

  function registerMultipleSwal(newUsers, numberOfUsers) {
    const locationObj = vm.event.locations.reduce((locations, location) => {
      locations[`${location.location}`] = location.location;
      return locations;
    }, {});
    if (newUsers)
      return Swal.fire(
        'Select Location',
        `This action will automatically register and add all selected users to Prolaera as public users and they will not have access to your company account.`,
        'select',
        locationObj
      );
    return Swal.fire('Select Location', `Register ${numberOfUsers} user(s) for this event.`, 'select', locationObj);
  }

  vm.registerMultipleinFirm = () => {
    const locationObj = vm.event.locations.reduce((locations, location) => {
      locations[`${location.location}`] = location.location;
      return locations;
    }, {});
    const selected = vm.registrations.filter(user => user.selected);
    vm.selected = 0;
    Swal.fire(
      'Select Location',
      `This action will automatically register and add all selected users to your organization in Prolaera and they will have full access to your company account.  This action is not recommended for any non-employee users.`,
      'select',
      locationObj
    )
      .then(data => {
        if (data.dismiss) throw data;
        vm.addRegistrants({ data: selected, suppress: !!vm.suppress, inFirm: true, location: data.value });
      })
      .then(() => {
        $state.go('.', {}, { notify: true, reload: true });
      })
      .catch(error => {
        if (error.dismiss) return;
        Swal.toast('Error with registrations', 'error');
        $log.error(error);
        throw error;
      });
  };

  vm.selectAll = (registrations, selectAllModel) => {
    registrations.forEach(user => (user.selected = selectAllModel));
    vm.updateSelected(registrations);
  };

  vm.updateSelected = registrations => {
    vm.selected = registrations.filter(registrant => registrant.selected).length;
  };

  vm.resetSelected = () => {
    vm.pendingRegistrants.forEach(registrant => (registrant.selected = false));
    vm.newRegistrants.forEach(registrant => (registrant.selected = false));
    vm.selected = 0;
  };

  function activate() {
    if (!vm.location) return;
    if (!vm.registrations) vm.registrations = [];

    vm.suppress = true;

    vm.registrations.forEach(registrant => {
      registrant.externalEmail = registrant.email;
    });

    vm.pendingRegistrants = vm.registrations.filter(({ profile_uid }) => profile_uid);
    vm.newRegistrants = vm.registrations.filter(({ profile_uid }) => !profile_uid);

    vm.loaded = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/event/webinarRegistrations/controller.js